import ImageStream from "./imageStream";

const getForwardCamera = (cameras: ImageStream[]) => {
  const forwardCamera = cameras.find((c) => isForwardCamera(c.cameraName));
  return forwardCamera;
};

const isForwardCamera = (cameraName: string) => {
  return cameraName.toLowerCase().includes("forward");
};

const imageStreamHelper = {
  getForwardCamera,
  isForwardCamera,
};

export default imageStreamHelper;
